import React from "react";
import { useQuery } from "@tanstack/react-query";
import { adminMarketBudget } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function MarketBudgetTab() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-market-budget"], queryFn: adminMarketBudget,
    refetchInterval: 30_000,
  });
  if (isLoading) return <Loader2 className="size-5 animate-spin text-white/50" />;
  const b = data || {};
  const pct = b.pct_remaining ?? 0;
  const color = pct < (b.low_threshold_pct ?? 20) ? "bg-red-400" : pct < 50 ? "bg-amber-400" : "bg-emerald-400";

  return (
    <div className="rounded-xl border border-white/10 bg-white/5 px-5 py-5 space-y-4" data-testid="admin-market-budget">
      <h2 className="text-base font-semibold">TwelveData daily quota</h2>
      <div className="space-y-1">
        <div className="text-3xl font-bold tabular-nums">
          {b.credits_remaining} <span className="text-base text-white/40">/ {b.daily_budget}</span>
          <span className="ml-2 text-sm text-white/60">({b.pct_remaining}% left)</span>
        </div>
        <div className="h-2 bg-white/10 rounded">
          <div className={`h-full rounded ${color}`} style={{ width: `${pct}%` }} />
        </div>
        <div className="text-xs text-white/50">Resets at: {b.reset_at}</div>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="rounded border border-white/10 px-3 py-2">
          <div className="text-xs text-white/40">Active poll interval</div>
          <div className="text-amber-200 font-semibold">{b.poll_interval_minutes} min</div>
        </div>
        <div className="rounded border border-white/10 px-3 py-2">
          <div className="text-xs text-white/40">Auto-throttle</div>
          <div className={b.auto_throttle_enabled ? "text-emerald-300" : "text-white/50"}>
            {b.auto_throttle_enabled ? "ENABLED" : "off"}
          </div>
        </div>
      </div>
      <p className="text-xs text-white/40">Change these settings in the <strong>Wallets & Config</strong> tab.</p>
    </div>
  );
}
